// extracted by mini-css-extract-plugin
export default {"headerBtn":"Accordion_headerBtn__L2FPD"};